module.exports = __webpack_public_path__ + "img/product-7.e3733c49.jpg";